import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { PageLayout, PageHeader } from '../components/ui/Layout';
import { Card } from '../components/ui/Card';
import { PrimaryButton, SecondaryButton } from '../components/ui/Button';
import { TextArea } from '../components/ui/Input';
import { parseRelationshipQuiz } from '../utils/xmlParser';

const { FiCheckCircle, FiAlertCircle, FiArrowLeft, FiCode, FiZap } = FiIcons;

export default function ImportQuiz() {
  const [xmls, setXmls] = useState({ q: '', d: '', s: '' });
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleImport = () => {
    try {
      if (!xmls.q || !xmls.d || !xmls.s) throw new Error("All three XML blocks are required.");
      const quizData = parseRelationshipQuiz(xmls.q, xmls.d, xmls.s);
      const existing = JSON.parse(localStorage.getItem('quizzes') || '[]');
      localStorage.setItem('quizzes', JSON.stringify([...existing, quizData]));
      navigate('/');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <PageLayout>
      <PageHeader title="IOWEU Engine Importer" description="Upload all three logical components." 
        action={<SecondaryButton onClick={() => navigate('/')}><SafeIcon icon={FiArrowLeft} className="mr-2" /> Back</SecondaryButton>} 
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <Card pSmall>
          <div className="flex items-center gap-2 mb-2 text-[#0270a9] text-sm font-bold uppercase"><SafeIcon icon={FiCode} /> Questions</div>
          <TextArea value={xmls.q} onChange={e => setXmls({...xmls, q: e.target.value})} className="h-48 text-[10px]" />
        </Card>
        <Card pSmall>
          <div className="flex items-center gap-2 mb-2 text-[#0270a9] text-sm font-bold uppercase"><SafeIcon icon={FiZap} /> Coaching</div>
          <TextArea value={xmls.d} onChange={e => setXmls({...xmls, d: e.target.value})} className="h-48 text-[10px]" />
        </Card>
        <Card pSmall>
          <div className="flex items-center gap-2 mb-2 text-[#0270a9] text-sm font-bold uppercase"><SafeIcon icon={FiCheckCircle} /> Scoring</div>
          <TextArea value={xmls.s} onChange={e => setXmls({...xmls, s: e.target.value})} className="h-48 text-[10px]" />
        </Card>
      </div>
      {error && <div className="p-4 bg-red-50 text-red-600 rounded-lg mb-6">{error}</div>}
      <PrimaryButton onClick={handleImport} className="w-full py-4 text-lg">Process & Save Quiz</PrimaryButton>
    </PageLayout>
  );
}